/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { publicIconPath } from '@orientaction/utils';
import classNames from 'classnames';
import { FC, useContext, useEffect, useMemo, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import style from './style';
import { AdminTestContext } from '@orientaction/Context';
import { TextField } from '@material-ui/core';
import { cloneDeep } from 'lodash';

interface IProps {
  accordionDetailsComponent?: any;
  accordionSummaryComponent?: any;
  summaryText: string;
  detailsText: string;
  accordionStyleOverride?: string;
  index: number;
  handleDelete: any;
  handleEdit: any;
  codeColor?: string;
  minInterval?: number;
  maxInterval?: number;
  diagram?: any;
  hasImage?: boolean;
}

const OaAccordion: FC<IProps> = ({
  summaryText,
  detailsText,
  accordionSummaryComponent,
  accordionDetailsComponent,
  accordionStyleOverride,
  index,
  handleDelete,
  handleEdit,
  codeColor,
  minInterval,
  maxInterval,
  diagram,
  hasImage,
}) => {
  const classes = style();

  const {
    updateTest,
    test: { aglomerations, toDeleteAglomerationsIds },
  } = useContext<any>(AdminTestContext);

  const [expanded, setExpanded] = useState<boolean>(false);
  const [modeEdit, setModeEdit] = useState<boolean>(false);
  const [variableName, setVariableName] = useState<string>(aglomerations[index]?.name);

  const handleTextChange = (e: any) => {
    const { value } = e.target;
    setVariableName(value);
  };
  const handleClickEdit = (e: any) => {
    e.stopPropagation();
    setModeEdit(!modeEdit);
  };

  const handleClickInput = (e: any) => {
    e.stopPropagation();
  };

  const handleDeleteVariable = (e: any) => {
    e.stopPropagation();
    const cloneAglomerations: any = cloneDeep([...aglomerations]);
    const idDeleted = cloneDeep([...toDeleteAglomerationsIds]);
    if (!cloneAglomerations[index]?.isNew) {
      idDeleted.push(cloneAglomerations[index]?.id);
    }
    updateTest({
      aglomerations: cloneAglomerations.filter((data: any, i: number) => index !== i),
      toDeleteAglomerationsIds: idDeleted,
    });
  };

  useEffect(() => {
    const cloneAglomerations = cloneDeep([...aglomerations]);
    cloneAglomerations[index].name = variableName;
    updateTest({
      aglomerations: cloneAglomerations,
    });
  }, [variableName]);

  const oaAccordionSummary = useMemo(() => {
    return (
      accordionSummaryComponent || (
        <AccordionSummary
          key={aglomerations[index]?.id}
          className={classes.accordionSummary}
          expandIcon={<ExpandMoreIcon style={{ color: '#000A8C' }} />}>
          <div className={classes.flexContainer}>
            <div
              key={aglomerations[index]?.id}
              className={classes.backgroundFloat}
              style={{ width: expanded ? '100%' : index >= 9 ? '128px' : '122px' }}
            />
            <div className={classes.circle}>
              <span className={classes.number}>Variable N°{`${index + 1}`}</span>
              {modeEdit ? (
                <TextField
                  id="test-variable-name"
                  variant="outlined"
                  className={classes.formInput}
                  name="variableName"
                  value={variableName}
                  onChange={handleTextChange}
                  onBlur={() => setModeEdit(false)}
                  onKeyDown={e => {
                    e.stopPropagation();
                    if (e.key === 'Enter') {
                      setModeEdit(false);
                    }
                  }}
                  onClick={handleClickInput}
                  autoFocus={true}
                />
              ) : (
                <span
                  className={classes.number}
                  style={{ marginLeft: 20, color: expanded ? 'white' : 'black' }}>
                  {variableName || 'Variable sans titre'}
                </span>
              )}
            </div>
            <div style={{ zIndex: 2 }}>
              <IconButton className={classes.iconButton} onClick={handleClickEdit}>
                <img
                  src={`${publicIconPath}/${expanded ? 'oa_edit_white.svg' : 'oa_edit.svg'}`}
                  color="white"
                  alt="Edit Icon"
                />
              </IconButton>
              <IconButton className={classes.iconButton} onClick={handleDeleteVariable}>
                <img
                  src={`${publicIconPath}/${expanded ? 'oa_trash_white.svg' : 'oa_trash.svg'}`}
                  alt="Custom Icon"
                />
              </IconButton>
            </div>
          </div>
        </AccordionSummary>
      )
    );
  }, [
    accordionSummaryComponent,
    classes.accordionSummary,
    classes.backgroundFloat,
    classes.circle,
    classes.flexContainer,
    classes.formInput,
    classes.iconButton,
    classes.number,
    expanded,
    handleDelete,
    index,
    modeEdit,
    variableName,
  ]);

  const handleChange = (panel: any) => (event: any, isExpanded: boolean) => {
    setExpanded(isExpanded);
  };

  return (
    <div className={classNames(classes.root, accordionStyleOverride)}>
      <Accordion TransitionProps={{ unmountOnExit: true }} onChange={handleChange(index)}>
        {oaAccordionSummary}
        <AccordionDetails className={classes.accordionDetails}>
          {accordionDetailsComponent() ?? ''}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default OaAccordion;
